// ----------------------------------------------------------------------------
// Snippet: Product Zoom
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------
// Scripts
import 'snippets/_containers/modal/modal';

// Styles
import './_product-sfp-zoom.scss';

// -------------------------------------
// Variables
// -------------------------------------
var MODAL_SELECTOR = '.modal--product-sfp-zoom';
var MODAL_CONTAINER_SELECTOR = "".concat(MODAL_SELECTOR, " .modal__content_media_container");
var HEADER_SELECTOR = '.shopify-section--header';
var SWIPER_WRAPPER_SELECTOR = '.product__ingredient-asset';
var ZOOM_TRIGGER_SELECTORS = [SWIPER_WRAPPER_SELECTOR];
var MODAL_CLOSE_SELECTORS = ['.close-zoom', '.icon-close-zoom'];
function initProductZoomModal() {
  var modal = document.querySelector(MODAL_SELECTOR);
  var modalContainer = document.querySelector(MODAL_CONTAINER_SELECTOR);
  var header = document.querySelector(HEADER_SELECTOR);
  if (!modal || !modalContainer) return;
  var isDesktop = () => window.innerWidth >= 1024;
  var populateModalContent = () => {
    var swiperWrapper = document.querySelector(SWIPER_WRAPPER_SELECTOR);
    if (!swiperWrapper) return;
    modalContainer.innerHTML = swiperWrapper.innerHTML;
  };
  var openModal = () => {
    if (!isDesktop()) return;
    modal.classList.add('modal--open');
    document.body.classList.add('noscroll');
    header === null || header === void 0 || header.classList.add('sendback');
    window.dispatchEvent(new CustomEvent('open.modal', {
      detail: modal
    }));
  };
  var closeModal = () => {
    if (!isDesktop()) return;
    modal.classList.remove('modal--open');
    document.body.classList.remove('noscroll');
    header === null || header === void 0 || header.classList.remove('sendback');
    window.dispatchEvent(new CustomEvent('close.modal', {
      detail: modal
    }));
  };
  var addEventListeners = () => {
    ZOOM_TRIGGER_SELECTORS.forEach(selector => {
      document.querySelectorAll(selector).forEach(el => el.addEventListener('click', e => openModal(e.target)));
    });
    MODAL_CLOSE_SELECTORS.forEach(selector => {
      document.querySelectorAll(selector).forEach(el => el.addEventListener('click', closeModal));
    });
  };
  populateModalContent();
  addEventListeners();
}

// Init on DOM load
document.addEventListener('DOMContentLoaded', () => {
  initProductZoomModal();
});